import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

const ValidatingTextField = ({
  isDisabled,
  isMandatory,
  markIfEmpty,
  validationFn,
  validationHelperText,
  value,
  isQuantityValid,
  quantityValidationText,
  ...props
}) => {
  const [isVisited, setIsVisited] = useState(false);
  const shouldMarkRed =
    ((isMandatory && isVisited) || markIfEmpty) && !value && !isDisabled;
  const isValueValid = validationFn && value ? validationFn(value) : true;

  return (
    <TextField
      onBlur={() => setIsVisited(true)}
      isDisabled={isDisabled}
      error={shouldMarkRed || !isValueValid || !isQuantityValid}
      helperText={!isValueValid ? validationHelperText :
        (!isQuantityValid ? quantityValidationText : null)}
      value={value}
      {...props}
    />
  );
};

ValidatingTextField.propTypes = {
  isDisabled: PropTypes.bool,
  isMandatory: PropTypes.bool,
  markIfEmpty: PropTypes.bool,
  validationFn: PropTypes.func.isRequired,
  validationHelperText: PropTypes.string,
  value: PropTypes.string,
  isQuantityValidor: PropTypes.bool,
};

export default ValidatingTextField;
